export function findSearchMatchTextNode(
  root: ParentNode,
  query: string
): { node: Text; start: number; length: number } | null {
  const needle = query.trim().toLowerCase()
  if (!needle) {
    return null
  }

  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT)

  let current: Node | null = walker.nextNode()
  while (current !== null) {
    const text = current.textContent ?? ''
    const index = text.toLowerCase().indexOf(needle)
    if (index !== -1) {
      return { node: current as Text, start: index, length: needle.length }
    }

    current = walker.nextNode()
  }

  return null
}
